import CustomText from '@/components/common/CustomText';

export default function NotFound() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            <CustomText fontSize="h1">404</CustomText>
        </div>
    );
}
